import React, { Fragment } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { arrayOf, func, shape, string, bool } from 'prop-types';

const StationLinks = ({
  terms,
  playStation,
  station,
  website,
  isPlaying,
  pauseStation
}) => (
  <Fragment>
    {!isPlaying ? (
      <Button primary onClick={() => playStation(station)}>
        <Icon name="play" />
        {terms[4]}
      </Button>
    ) : (
      <Button primary onClick={() => pauseStation()}>
        <Icon name="pause" />
        {terms[5]}
      </Button>
    )}

    <Button
      secondary
      as="a"
      href={website}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon name="external" />
      {terms[6]}
    </Button>
  </Fragment>
);

StationLinks.propTypes = {
  terms: arrayOf(string).isRequired,
  playStation: func.isRequired,
  station: shape().isRequired,
  website: string.isRequired,
  isPlaying: bool.isRequired,
  pauseStation: func.isRequired
};

export default StationLinks;
